// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.toast-content[data-v-5f218894] {
  text-align: center;
  padding: 8px 4px 16px;
}
.toast-icon-wrapper[data-v-5f218894] {
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.toast-icon-x-circle[data-v-5f218894] {
  color: #E67774;
  font-size: 5rem;
}
.toast-icon-circle-warning[data-v-5f218894] {
  width: 112px;
  height: 112px;
  border-radius: 50%;
  border: 5px solid #f5d0a0;
  background-color: #fff;
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.toast-icon-exclamation[data-v-5f218894] {
  color: #fcc754;
  font-size: 5rem;
  font-weight: bold;
}
.toast-icon-circle-success[data-v-5f218894] {
  width: 112px;
  height: 112px;
  border-radius: 50%;
  border: 5px solid #E3F5DA;
  background-color: #fff;
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.toast-icon-check2[data-v-5f218894] {
  color: #A1DB83;
  font-size: 5.5rem;
  font-weight: bold;
}
.toast-title[data-v-5f218894] {
  font-weight: 700;
  font-size: 1.25rem;
  color: #111;
  margin-bottom: 8px;
}
.toast-message[data-v-5f218894] {
  color: #222;
  font-size: 0.95rem;
  margin-bottom: 16px;
  line-height: 1.4;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
